import React from 'react';
import { Check, X } from 'lucide-react';
export function Comparison() {
  const rows = [{
    bad: 'Decorás gratis "por que ya lo hacés bien"',
    good: 'Cobrás con un presupuesto claro'
  }, {
    bad: 'Comprás de más sin saber cómo va a quedar',
    good: 'Proyectás con IA antes de gastar'
  }, {
    bad: 'No tenés contrato ni seña',
    good: 'Plantillas listas para trabajar en serio'
  }, {
    bad: 'Un solo tipo de evento que se te da bien',
    good: '6 categorías de eventos resueltas'
  }, {
    bad: 'Pinterest sin orden ni sistema',
    good: 'Sistema completo paso a paso'
  }];
  return <section className="py-12 px-5 bg-white" data-id="element-52">
      <div className="max-w-md mx-auto" data-id="element-53">
        <h2 className="text-2xl font-bold text-wine text-center mb-8" data-id="element-54">
          Sin Decora Fácil PRO vs. Con Decora Fácil PRO
        </h2>

        <div className="bg-cream/20 rounded-2xl border border-cream overflow-hidden" data-id="element-55">
          <div className="grid grid-cols-2 bg-cream/50 p-3 border-b border-cream" data-id="element-56">
            <div className="text-center font-bold text-sm text-dark/60 flex flex-col items-center gap-1" data-id="element-57">
              <X className="w-4 h-4 text-red-400" data-id="element-58" /> Sin el sistema
            </div>
            <div className="text-center font-bold text-sm text-wine flex flex-col items-center gap-1" data-id="element-59">
              <Check className="w-4 h-4 text-green-500" data-id="element-60" /> Con el sistema
            </div>
          </div>

          <div className="divide-y divide-cream/50" data-id="element-61">
            {rows.map((row, idx) => <div key={idx} className="grid grid-cols-2 p-3" data-id="element-62">
                <div className="text-[13px] text-dark/70 pr-2 flex items-start gap-1.5" data-id="element-63">
                  <span className="text-red-400 font-bold mt-0.5" data-id="element-64">✗</span>{' '}
                  {row.bad}
                </div>
                <div className="text-[13px] text-wine font-medium pl-2 border-l border-cream/50 flex items-start gap-1.5" data-id="element-65">
                  <span className="text-green-500 font-bold mt-0.5" data-id="element-66">✓</span>{' '}
                  {row.good}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}